var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.21303,
    cy: 19.445,
    r: 6.62269,
    fill: "#FCB900"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4933,
    cy: 7.54799,
    r: 6.62269,
    fill: "#B3B2B2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5836,
    cy: 19.445,
    r: 6.62269,
    fill: "#B84D35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedals);
export default __webpack_public_path__ + "static/media/medals.2d841dc091967189f0c3c169b7b23460.svg";
export { ForwardRef as ReactComponent };